import * as types from '../actions/actionTypes';
import initialState from './initialState';
import { USER } from '../store/constants';

const reducer = (state = initialState[USER], action) => {
  switch (action.type) {
    case types.LOAD_CURRENT_USER_INFO.REQUEST: {
      return {
        ...state,
        fetching: true
      };
    }
    case types.LOAD_CURRENT_USER_INFO.SUCCESS: {
      const { currentUser } = action.payload;
      return {
        ...state,
        ...currentUser,
        fetching: false
      };
    }
    case types.LOAD_CURRENT_USER_INFO.FAILURE: {
      return {
        ...state,
        fetching: false
      };
    }
    case types.CLEAR_USER_SESSION: {
      return {};
    }
    default:
      return state;
  }
};

export default reducer;
